import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NotePencil } from "@phosphor-icons/react";
import api from "../lib/api";

export const CALL_TYPE_LABELS = {
  phone_call: "Phone Call", text: "Text Message", email: "Email", in_person: "In Person",
  home_visit: "Home Visit", introduction: "Intro / Meet & Greet", note: "Note",
};

export default function PersonCallLogCard({ kind, pid }) {
  const [entries, setEntries] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (!pid) return;
    api.get(`/call-log/person/${kind}/${pid}`).then((r) => setEntries(r.data.entries || [])).catch(() => setEntries([]));
  }, [kind, pid]);
  if (entries === null) return null;
  return (
    <div className="mt-6 rounded-xl border border-stone-200 bg-white p-5 shadow-sm" data-testid={`call-log-card-${kind}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="font-heading text-sm font-semibold text-stone-900">Call &amp; contact log</p>
          <p className="mt-0.5 text-xs text-stone-400">{entries.length} {entries.length === 1 ? "entry" : "entries"} on file</p>
        </div>
        <button onClick={() => navigate(`/call-log?${kind}=${pid}`)}
          className="inline-flex items-center gap-1 rounded-full border border-stone-300 px-3 py-1.5 text-xs font-medium text-stone-700 transition-colors hover:bg-stone-900 hover:text-white"
          data-testid={`call-log-add-${kind}`}>
          <NotePencil size={13} /> Log a call / note
        </button>
      </div>
      {entries.length > 0 && (
        <div className="mt-3 space-y-1.5" data-testid={`call-log-entries-${kind}`}>
          {entries.slice(0, 10).map((e) => (
            <div key={e.id} className="rounded-lg border border-stone-100 px-4 py-2" data-testid={`call-log-entry-${e.id}`}>
              <p className="text-xs text-stone-500">
                <span className="font-medium text-stone-700">{e.entry_date}</span>
                {" · "}{CALL_TYPE_LABELS[e.doc_type] || e.doc_type}
                {e.contact_name ? ` · ${e.contact_name}` : ""}
                {e.follow_up?.needed && !e.follow_up?.done && (
                  <span className="ml-2 rounded bg-[#B7791F]/10 px-1.5 py-0.5 text-[10px] font-bold text-[#8a5d14]">FOLLOW-UP</span>
                )}
              </p>
              <p className="mt-0.5 whitespace-pre-wrap text-xs text-stone-600">{e.notes}</p>
            </div>
          ))}
          {entries.length > 10 && (
            <button onClick={() => navigate(`/call-log?${kind}=${pid}`)} className="text-xs font-medium text-primary hover:underline" data-testid={`call-log-more-${kind}`}>
              View all {entries.length} in the call log →
            </button>
          )}
        </div>
      )}
    </div>
  );
}
